export default __webpack_public_path__ + "static/media/logo _uyqur.da69f158.png";